import { GetCreditLevelConfig } from "@/types/Api/Common/CreditLevel/getCreditLevelConfig";
import { GetConfig } from "@/types/Api/Common/Home/getConfig";
import { APICommonVerifyCodeGetImageCode } from "@/types/Api/Common/Home/getImageCode";
import { request } from "@/utils/request";

// 获取验证码图片 base64
export const getImageCode = (data: { codeType: string }) =>
  request<APICommonVerifyCodeGetImageCode>({
    url: "/Api/Common/VerifyCode/getImageCode",
    method: "POST",
    data,
  });

// 获取短信验证码
export const getSMSCode = (data: { codeType: string; phoneNumber: string }) =>
  request<string>({
    url: "/Api/Common/VerifyCode/sendCode",
    method: "POST",
    data,
  });

export const getConfig = (data: any) =>
  request<GetConfig>({
    url: "/Api/Common/Home/getConfig",
    method: "GET",
    data,
  });

export const getHomePagePopupInfo = () =>
  request<any>({
    url: "/Api/Common/Home/getHomePagePopupInfo",
    method: "GET",
});

export const getQRCodeLoginUuid = (data: any) =>
  request<{ uuid: string }>({
    url: "/Api/Common/QRLogin/getQRCodeLoginUuid",
    method: "GET",
    data,
  });

// 获取等级信息介绍
export const getCreditLevelConfig = (data: GetCreditLevelConfig["request"]) =>
  request<GetCreditLevelConfig["response"]>({
    url: "/Api/Common/CreditLevel/getCreditLevelConfig",
    method: "GET",
    data,
  });

export const checkVerifyCode = (data: any) =>
  request<any>({
    url: "/Api/Common/VerifyCode/checkVerifyCodeNew",
    method: "POST",
    data,
  });

export const sendCode = (data: any) =>
  request<any>({
    url: "/Api/Common/VerifyCode/sendCode",
    method: "POST",
    data,
  });

export const upload = (data: FormData) =>
  request<{ name: string }>({
    url: "/Api/User/UploadFile/uploadImg",
    method: "POST",
    data,
  });

export const postAuthorizeRegister = (data: {authToken:string}) =>
  request<any>({
    url: "/Api/Common/Home/authorizeRegister",
    method: "POST",
    data,
  });

export const postQRCodeLoginAuthorize = (data: {authToken:string, securePassword: string}) =>
  request<any>({
    url: "/Api/User/MyAccount/QRCodeLoginAuthorize",
    method: "POST",
    data,
  });